import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIEndpoints } from '@core/config/apiendpoint';
import { ApiService } from '@core/services/api-service/api.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(private http: HttpClient, private apiService: ApiService) { }

  getTokenValidation() {
    return this.apiService.get(APIEndpoints.authentication, '').pipe(map((res) => res));
  }

  getPersons(requestParam: any) {
    return this.apiService.get(APIEndpoints.getAllEmployee, requestParam).pipe(map((res) => res));
  }
  getSearchData(requestParam: any) {
    return this.apiService.get(APIEndpoints.getSearchData, requestParam).pipe(map((res) => res));
  }
  getFilterData(requestParam: any) {
    return this.apiService.get(APIEndpoints.getFilterData, requestParam).pipe(map((res) => res));
  }

  getLocationData(requestParam: any) {
    return this.apiService.get(APIEndpoints.getLocationData, requestParam).pipe(map((res) => res));
  }

  getAreaData(requestParam: any) {
    return this.apiService.get(APIEndpoints.getAreaData, requestParam).pipe(map((res) => res));
  }

  getDepartmentData(requestParam: any) {
    return this.apiService.get(APIEndpoints.getDepartmentData, requestParam).pipe(map((res) => res));
  }

  getPersonDetails(requestParam: any) {
    return this.apiService.get(APIEndpoints.getPersonDetails, requestParam).pipe(map((res) => res));
  }

  getCreatedAndAllocatedIDDetails(requestParam: any) {
    return this.apiService.get(APIEndpoints.getCreatedAndAllocatedData, requestParam).pipe(map((res) => res));
  }

  generateEntityName(data: any, requestParam: any) {
    return this.apiService.post(APIEndpoints.generateEntityID, data, requestParam).pipe(map((res) => res));
  }

  deallocateEntityAllocated(data: any, requestParam: any) {
    return this.apiService.post(APIEndpoints.deallocateAllocatedID, data, requestParam).pipe(map((res) => res));
  }

}
